var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c(
      "div",
      { staticClass: "scroll" },
      [
        _c("contents-header", {
          attrs: {
            "bg-type": true,
            "no-radius": true,
            tabs: true,
            title: "MOTP-01-07-01-01",
            description: "MOTP-01-07-01-02"
          },
          scopedSlots: _vm._u([
            {
              key: "tab",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "tabs bg-type", attrs: { id: "tabs" } },
                    _vm._l(_vm.tabs, function(tab, index) {
                      return _c(
                        "button",
                        {
                          key: index,
                          staticClass: "tab-button tab-button--type1",
                          class: { active: _vm.currentTab === index },
                          on: {
                            click: function($event) {
                              _vm.currentTab = index
                            }
                          }
                        },
                        [
                          _vm.token
                            ? _c("i", { staticClass: "icon icon-attestation2" })
                            : _c("i", {
                                staticClass: "icon icon-attestation3"
                              }),
                          _c("span", { staticClass: "btn-text" }, [
                            _vm._v(_vm._s(tab))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              },
              proxy: true
            }
          ])
        }),
        _c("article", { staticClass: "contents" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab == 0,
                  expression: "currentTab == 0"
                }
              ]
            },
            [
              _c(
                "div",
                { staticClass: "form" },
                [
                  _c("div", { staticClass: "form-row" }, [
                    _c(
                      "div",
                      { staticClass: "item-desc" },
                      [
                        _c("select-box", {
                          ref: "smsCnpt",
                          attrs: {
                            value:
                              _vm.$store.state.auth.commMotpCertn.sendCetrNo.in
                                .cphnNo,
                            "option-list": _vm.getSMSCnptList,
                            "label-i18n": "MOTP-01-07-01-03",
                            required: _vm._.isEmpty(
                              _vm.getRBF0409E40.out.success.emad1
                            )
                          },
                          on: {
                            "update:value": function($event) {
                              return _vm.$set(
                                _vm.$store.state.auth.commMotpCertn.sendCetrNo
                                  .in,
                                "cphnNo",
                                $event
                              )
                            },
                            selected: _vm.selectedCpnt
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "item-tit" }, [
                      _vm._v(_vm._s(/*이메일 주소*/ _vm.$t("MOTP-01-07-01-04")))
                    ]),
                    _c("div", { staticClass: "item-desc" }, [
                      _c("div", { staticClass: "form-text-field email" }, [
                        _c("div", { staticClass: "input-text-field" }, [
                          _c("input", {
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "name",
                              placeholder: "",
                              disabled: ""
                            },
                            domProps: {
                              value: _vm.getRBF0409E40.out.success.emad1
                            }
                          })
                        ])
                      ])
                    ])
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "info info-help",
                      on: {
                        click: function($event) {
                          _vm.actionSheet003 = true
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "icon icon-help" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            /*휴대폰 번호나 이메일 주소를 변경하셨나요?*/ _vm.$t(
                              "MOTP-01-07-01-05"
                            )
                          ) +
                          " "
                      )
                    ]
                  ),
                  _c("sms-email-info-pop", {
                    attrs: { opened: _vm.actionSheet003 },
                    on: {
                      "update:opened": function($event) {
                        _vm.actionSheet003 = $event
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab == 1,
                  expression: "currentTab == 1"
                }
              ]
            },
            [
              _vm.getRBF0409E40.out.success.scurtyDeviVndrDstcd === "004" ||
              _vm.getRBF0409E40.out.success.scurtyDeviVndrDstcd === "304"
                ? _c(
                    "article",
                    [
                      _c("div", { staticClass: "form" }, [
                        _c("div", { staticClass: "form-text-field" }, [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: "name" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  /*발급된 OTP 기기 일련번호*/ _vm.$t(
                                    "MOTP-01-07-02-03"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "input-text-field",
                              on: {
                                click: function($event) {
                                  _vm.type3 = true
                                }
                              }
                            },
                            [
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "name",
                                  placeholder: "",
                                  maxlength: "15",
                                  readonly: ""
                                },
                                domProps: {
                                  value:
                                    _vm.getRBF0409E40.out.success.otpUniqIdnfiNo
                                }
                              })
                            ]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "info info-help",
                            on: {
                              click: function($event) {
                                _vm.actionSheet004 = true
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "icon icon-help" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  /*발급된 OTP 기기 일련번호*/ _vm.$t(
                                    "MOTP-01-07-02-03"
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("action-sheet", {
                        staticClass: "action-sheet",
                        attrs: {
                          opened: _vm.actionSheet004,
                          "action-header": true,
                          "action-footer": true,
                          "use-top-border": true,
                          title: "MOTP-01-07-04-01"
                        },
                        on: {
                          "update:opened": function($event) {
                            _vm.actionSheet004 = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function() {
                                return [
                                  _c(
                                    "ul",
                                    { staticClass: "ulist ulist-type--bullet" },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            /* 지점에서 발급받은 TokenOTP 발생기 뒷면을 보시면 ①을 확인 하실 수 있습니다. */ _vm.$t(
                                              "MOTP-01-07-04-02"
                                            )
                                          )
                                        )
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          _vm._s(
                                            /* TokenOTP를 분실한 경우, 영업점에서 재발급이 가능합니다. */ _vm.$t(
                                              "MOTP-01-07-04-04"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _c("div", { staticClass: "cont-img" }, [
                                    _c("i", {
                                      staticClass: "icon icon-token-otp-sn"
                                    })
                                  ])
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "footer",
                              fn: function() {
                                return [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn bottom positive",
                                      on: {
                                        click: function($event) {
                                          _vm.actionSheet004 = !_vm.actionSheet004
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          /*확인*/ _vm.$t("MOTP-01-07-03-05")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1869809720
                        )
                      })
                    ],
                    1
                  )
                : _c("article", [
                    _vm._m(0),
                    _c("strong", {
                      staticClass: "info-question",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("MOTP-08-01-02-02"))
                      }
                    })
                  ])
            ]
          )
        ])
      ],
      1
    ),
    _c("div", { staticClass: "btn-area--full fixed" }, [
      _c(
        "button",
        {
          class: "btn md " + (_vm.FN004() ? "normal" : "disabled"),
          on: { click: _vm.FN002 }
        },
        [_vm._v(_vm._s(/*다음*/ _vm.$t("MOTP-01-07-02-05")))]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cont-img" }, [
      _c("i", { staticClass: "icon icon-token-otp op50" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }